/**
 * 是否是base640
 */
function isBase64(src) {
    return /^data:/.test(src);
}
/**
 * 浏览器是否支持 webp
 */
function checkIsSupportWebp() {
    try {
        return (document
            .createElement('canvas')
            .toDataURL('image/webp', 0.5)
            .indexOf('data:image/webp') === 0);
    }
    catch (err) {
        return false;
    }
}
var isSupportWebp = checkIsSupportWebp();
/**
 * 添加query
 */
function addQuery(url, query) {
    if (url === void 0) { url = ''; }
    var prefix = '';
    if (url.indexOf('?') !== -1) {
        prefix = '&';
    }
    else {
        prefix = '?';
    }
    return url + prefix + query;
}
/**
 * 匹配 background url
 */
var reg = /url\([^]+\)/g;
/**
 * 缩放的webp图片query
 */
var miniWebpQuery = 'x-s3-process=image/format,webp,image/resize,p_10';
/**
 * 高清的webp图片query
 */
var webpQuery = 'x-s3-process=image/format,webp';
/**
 * 缩放的原图格式图片query
 */
var miniQuery = 'x-s3-process=image/resize,p_10';
/**
 * 缩略图地址
 */
function miniSrc(originSrc) {
    if (isSupportWebp) {
        return addQuery(originSrc, miniWebpQuery);
    }
    return addQuery(originSrc, miniQuery);
}
/**
 * 高清图地址
 */
function hdSrc(originSrc) {
    if (isSupportWebp) {
        return addQuery(originSrc, webpQuery);
    }
    return originSrc;
}
/**
 *
 * @param originString 图片地址
 * @param effect 渐进的操作dom, 使图片平滑加载
 * @param opacity 初始的透明度
 */
var preLoadImgFactory = function (originSrc, effect, useWebp, opacity) {
    return function (el) {
        // 如果是base64
        if (isBase64(originSrc)) {
            effect(originSrc);
            return;
        }
        // 处理后的图片
        var effectedSrc = useWebp ? hdSrc(originSrc) : originSrc;
        // 加载小图
        effect(miniSrc(originSrc));
        el.style.opacity = opacity;
        var img = new Image();
        img.src = effectedSrc;
        // 图片加载完成
        img.onload = function () {
            /**
             * 加载大图
             * 这里做了部分兼容, 如果css里有写background-image的话, 这里需要把元素里的background-image清空, 避免在禁用cache的时候, 图片抖动
             */
            (el.tagName.toLocaleLowerCase() !== 'img' && !useWebp)
                ? el.style.backgroundImage = ''
                : effect(effectedSrc);
            el.style.opacity = '1';
            el.style.transition = 'opacity 0.7s';
        };
    };
};
/**
 * 处理<img c-webp src="xx">的情况
 */
var processImgTag = function (el) {
    var originSrc = el.getAttribute('src') || '';
    if (originSrc) {
        el.dataset.webpCache = originSrc;
        var effect = function (src) {
            el.setAttribute('src', src);
        };
        var preload = preLoadImgFactory(originSrc, effect, true, '.5');
        preload(el);
    }
};
/**
 * 处理css里的图片
 * @param srcString: 表示v-webp里的表达式
 */
var processCssBackground = function (el, srcString) {
    var cssProps = window.getComputedStyle(el, null);
    var hasBgImg = cssProps
        .getPropertyValue('background')
        .includes('url(');
    var originSrc = '';
    var useWebp = false;
    // 如果直接指定background-image了的话, 浏览器会直接加载原图, 没法阻止, 这个时候就不能用webp了, 避免浪费流量
    if (hasBgImg) {
        var url = cssProps
            .getPropertyValue('background')
            .match(reg);
        if (url) {
            originSrc = url[0].split('"')[1];
        }
    }
    else if (srcString) {
        originSrc = srcString;
        // 在v-imgPro="xxx" 里的图片才能享受 webp压缩
        useWebp = true;
    }
    if (!originSrc)
        return;
    el.dataset.webpCache = originSrc;
    var effect = function (src) {
        el.style.backgroundImage = "url(\"" + src + "\")";
    };
    var preload = preLoadImgFactory(originSrc, effect, useWebp, '.81');
    preload(el);
};
/**
 * 入口函数
 * @param el
 * @param srcString 背景图的地址
 */
var processImg = function (el, srcString) {
    /**
     * 避免子组件更新, 造成重复的图片处理
     */
    var webpCache = el.dataset.webpCache;
    if (webpCache) {
        return;
    }
    /**
     * 判断 dom 节点类型
     */
    if (el.tagName.toLocaleLowerCase() === 'img') {
        /**
         * 处理img标签
         */
        processImgTag(el);
    }
    else {
        /**
         * 处理css里的图片
         */
        processCssBackground(el, srcString);
    }
};
/**
 * 指令配置
 */
var webp = {
    inserted: function (el, binding) {
        processImg(el, binding.value);
    },
    update: function (el, binding) {
        processImg(el, binding.value);
    }
};
var install = function (Vue) {
    Vue.directive('webp', webp);
};
export default {
    install: install,
    webp: webp,
};
